/**
 * TODO 画面の表示モード（一覧 / カンバン / カレンダー）。
 *
 * 画面を開き直しても前回のモードに戻すため localStorage に保存する。
 * Home のクイック追加でも同じ条件で Todo を読み込めるよう、ここにまとめる。
 */

export type TodoViewMode = 'list' | 'kanban' | 'calendar'

const STORAGE_KEY = 'todo-view-mode'

export const readStoredViewMode = (): TodoViewMode => (localStorage.getItem(STORAGE_KEY) as TodoViewMode) || 'list'

export const storeViewMode = (mode: TodoViewMode): void => localStorage.setItem(STORAGE_KEY, mode)

/** カレンダーでは完了済みも表示するため、showDone に関係なく完了済みを含める */
export const shouldIncludeDone = (mode: TodoViewMode, showDone: boolean): boolean => mode === 'calendar' || showDone
